export const environment = {
  production: false,
  // Em dev as chamadas são relativas para passar pelo proxy do ng serve (proxy.conf.json),
  // evitando CORS contra a API remota. O proxy encaminha /core, /sales, etc. ao backend.
  apiBaseUrl: ''
};
